import { z } from 'zod';
import { createSortablePaginationSchema } from '../../../shared/index.js';
export var MeetingBodySearchFilterType;
(function (MeetingBodySearchFilterType) {
    MeetingBodySearchFilterType["ALL"] = "all";
    MeetingBodySearchFilterType["OPEN"] = "open";
})(MeetingBodySearchFilterType || (MeetingBodySearchFilterType = {}));
// Search schema for boards with pagination and filtering
export const meetingBodySearchSchema = createSortablePaginationSchema(['name']).extend({
    filterType: z.enum(Object.values(MeetingBodySearchFilterType)).optional(),
    meetingBodyCategoryId: z.number('Meeting body category ID must be a number').optional(),
    searchQuery: z.string().optional(),
});
// Contact form schema for sending messages to meeting body staff
export const meetingBodyMessageSchema = z.object({
    senderEmail: z.email('Please enter a valid email address'),
    senderName: z.string().min(1, 'Name is required').max(100, 'Name is too long'),
    message: z
        .string('Message is required')
        .min(1, 'Message is required')
        .max(5000, 'Message is too long'),
});
